import { IColor } from '../../common/types';

export const Colors: IColor = {
  B50: '#DEEBFF',
  B75: '#B3D4FF',
  B100: '#4C9AFF',
  B200: '#2684FF',
  B300: '#0065FF',
  B400: '#0052CC',
  B500: '#0747A6',
  BLACK: '#1b1b1b',
  DB100: '#27292D',
  G100: '#3a3a3a',
  DG100: '#434549',
  G200: '#6a6a6a',
  G300: '#9c9c9c',
  G400: '#cccccc',
  G500: '#e6e6e6',
  G600: '#eeeeee',
  DG600: '#2F3136',
  G700: '#fafafa',
  G800: '#F1F1F1',
  R50: '#FFEBE6',
  R75: '#FFBDAD',
  R100: '#FF8F73',
  R200: '#ff7452',
  R300: '#ff5630',
  R400: '#de350b',
  R500: '#DF1A1A',
  DR500: '#ff0000',
  WHITE: '#ffffff',
};
